import React from 'react';
import { ECareLogo } from '../../ui/Logo/LogoPlaceholder';
import { useMockUser } from '../../../context/MockUserContext';
import Select from '../../ui/Select';
import styles from './Banner.module.css';

// The blue bar at the top of the pages that sit inside AppLayout. It is
// position: fixed, and the padding that clears it lives in AppLayout — so the
// full-screen flows (goal setting, update goals, the CAFY intro), which render
// outside AppLayout, each carry their own banner in normal flow instead.
const Banner = ({ className = '', onLogoClick }) => {
	const { users, currentUserId, setCurrentUserId } = useMockUser();

	return (
		<div className={`${styles.blueBanner} ${className}`}>
			<div className={styles.bannerContent}>
				<button
					className={styles.logoButton}
					onClick={onLogoClick}
					aria-label='Go to home page'
					type='button'
				>
					<ECareLogo size='medium' className={styles.logo} />
				</button>

				{users.length > 0 && (
					<Select
						className={styles.userSelect}
						align='end'
						label='Switch mock user'
						value={currentUserId}
						onChange={setCurrentUserId}
						options={users.map((u) => ({ value: u.id, label: u.name }))}
					/>
				)}
			</div>
		</div>
	);
};

export default Banner;
